import { StatsCard } from '@/components/ui/StatsCard'
import { ROUTES } from '@/constants/routes'
import { useLeadsStats } from '@/features/leads/hooks/useLeads'
import { Box, Grid, Heading, Text, VStack } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

/**
 * Dashboard Page
 * Main dashboard with statistics and widgets
 */
export function Dashboard() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { data, isLoading } = useLeadsStats()

  const stats = data?.data || {}

  const handleNewLeadsClick = () => {
    navigate(ROUTES.LEADS + '?status=NEW')
  }

  const handleOverdueClick = () => {
    navigate(ROUTES.LEADS + '?is_overdue=true')
  }

  const handleUnassignedClick = () => {
    navigate(ROUTES.LEADS + '?assigned_to=')
  }

  return (
    <Box>
      <VStack spacing={6} align="stretch">
        {/* Header */}
        <Box>
          <Heading size="lg" color="#172B4D" mb={1}>
            {t('dashboard.title')}
          </Heading>
          <Text color="#5E6C84" fontSize="14px">
            {t('dashboard.welcome')}
          </Text>
        </Box>

        {/* Stats Cards */}
        <Grid
          templateColumns={{
            base: '1fr',
            md: 'repeat(2, 1fr)',
            lg: 'repeat(3, 1fr)',
          }}
          gap={4}
        >
          <StatsCard
            icon="🆕"
            label={t('dashboard.newLeads')}
            value={stats.new_leads_count}
            color="#0052CC"
            isLoading={isLoading}
            onClick={handleNewLeadsClick}
          />
          <StatsCard
            icon="⏰"
            label={t('dashboard.overdue')}
            value={stats.overdue_count}
            color="#DE350B"
            isLoading={isLoading}
            onClick={handleOverdueClick}
          />
          <StatsCard
            icon="👤"
            label={t('dashboard.unassigned')}
            value={stats.unassigned_count}
            color="#FF8B00"
            isLoading={isLoading}
            onClick={handleUnassignedClick}
          />
        </Grid>
      </VStack>
    </Box>
  )
}

export default Dashboard
